import React from "react";
import { Link } from 'react-router-dom';
import { FaLinkedin, FaInstagram, FaTiktok } from "react-icons/fa";
import "../styles/Footer.css";
import "../styles/index.css";
import { MdEmail } from "react-icons/md";

const Footer = () => {
  const socialIconSize = `2rem`;
  return (
    <footer className="footer">
      <div className="footer-logo">
        <img src="/logo.png" alt="Website Logo" className="logo-img" />
        <span className="website-name">GIFT BAGS BY RACHAEL</span>
      </div>
      <div className="footer-links link">
        <Link to="/brands">Brands</Link>
        <Link to="/events">Events</Link>
        <Link to="/gallery">Gallery</Link>
        <Link to="/press">Press</Link>
        <Link to="/about">About</Link>
        <Link to="/contact">Contact</Link>
      </div>
      <div className="footer-socials">
        <Link to="https://www.tiktok.com/@giftbagsbyrachael?lang=en" target="_blank" rel=" noreferrer">
          <FaTiktok className="social-icon" size={socialIconSize} />
        </Link>
        <Link to="https://www.instagram.com/giftbagsbyrachael/" target="_blank" rel=" noreferrer">
          <FaInstagram className="social-icon" size={socialIconSize} />
        </Link>
        <Link to="https://www.linkedin.com/in/rachaelhonowitz/" target="_blank" rel=" noreferrer">
          <FaLinkedin className="social-icon" size={socialIconSize} />
        </Link>
        <Link to="mailto:info@giftbagsbyRachael.com" target="_blank" rel=" noreferrer">
          <MdEmail className="social-icon" size={socialIconSize} />
        </Link>
      </div>
    </footer>
  );
};

export default Footer;